export default __webpack_public_path__ + "static/media/sophos.b8b1421b.svg";